(function () {
  if (customElements.get('mern-room-film')) return;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  class MernRoomFilm extends HTMLElement {
    connectedCallback() {
      var self = this;
      var mob = window.matchMedia('(max-width: 860px)').matches;
      this.rooms = [].slice.call(this.querySelectorAll('.mrf__room')).map(function (t) {
        var d = t.dataset;
        return { t: (mob ? [d.tm, d.t] : [d.t, d.tm]).filter(Boolean), l: (mob ? [d.lm, d.l] : [d.l, d.lm]).filter(Boolean), p: mob ? (d.pm || d.p) : d.p, nav: d.nav, focus: (parseFloat(d.focus) || 50) / 100, html: t.innerHTML };
      });
      if (!this.rooms.length) return;
      this.vids = [].slice.call(this.querySelectorAll('.mrf__v'));
      this.front = 0; this.cur = 0; this.token = 0; this.focusNow = this.rooms[0].focus;
      this.cap = this.querySelector('.mrf__cap');
      this.black = this.querySelector('.mrf__black');
      this.end = this.querySelector('.mrf__end');
      this.foot = this.querySelector('.mrf__foot');
      this.count = this.querySelector('.mrf__count');
      this.dots = [].slice.call(this.querySelectorAll('.mrf__dot'));
      this.prev = this.querySelector('.mrf__prev');
      this.next = this.querySelector('.mrf__next');
      this.poster = this.querySelector('.mrf__poster');
      this.still = this.querySelector('.mrf__still');
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var mode = this.dataset.mode || 'auto';
      this.lite = mode === 'photos' || (mode === 'auto' && !!c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
      if (this.poster) this.poster.style.objectPosition = this.pos(this.focusNow) + ' 50%';

      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.jump(+d.dataset.i); }); });
      this.next.addEventListener('click', function () {
        if (self.cur < self.rooms.length - 1) self.play(self.cur + 1);
        else { self.cap.classList.remove('is-on'); self.black.classList.add('is-on'); setTimeout(function () { self.openEnd(); }, 900); }
      });
      this.prev.addEventListener('click', function () { if (self.cur > 0) self.jump(self.cur - 1); });
      this.querySelector('.mrf__again').addEventListener('click', function () { self.play(0); });

      var start = function () { if (self.started) return; self.started = true; self.play(0); };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) start(); }, { rootMargin: '200px' });
        this.io.observe(this);
      } else start();
      document.addEventListener('shopify:block:select', this.onSel = function (e) {
        var i = [].slice.call(self.querySelectorAll('.mrf__room')).indexOf(e.target);
        if (i > -1) self.jump(i);
      });
      window.addEventListener('resize', this.onResize = function () { self.vids.forEach(function (v) { v.style.transition = 'opacity .5s ease'; v.style.objectPosition = self.pos(self.focusNow) + ' 50%'; }); });
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onSel) document.removeEventListener('shopify:block:select', this.onSel);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
    // On narrow screens the 16:9 film is cropped. Keep the room's subject (its focus point) in view.
    pos(c) {
      var r = this.clientWidth / Math.max(1, this.clientHeight), v = r / (16 / 9);
      if (v >= 1) return '50%';
      var p = (c - v / 2) / (1 - v);
      return (Math.max(0, Math.min(1, p)) * 100).toFixed(1) + '%';
    }
    warm(i) {
      var r = this.rooms[i]; if (!r || r.warm) return; r.warm = true;
      [r.t[0], r.l[0]].forEach(function (u) { if (u) { var v = document.createElement('video'); v.preload = 'auto'; v.muted = true; v.src = u; } });
    }
    setCopy(i) {
      var r = this.rooms[i];
      this.cap.innerHTML = r.html;
      this.count.textContent = pad(i + 1) + ' / ' + pad(this.rooms.length);
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      this.prev.disabled = i === 0;
      var n = this.rooms[i + 1];
      this.next.querySelector('b').textContent = n ? n.nav : '';
    }
    // Slow connection: stop the film and show one photo per room instead.
    goLite() {
      if (this.lite) return;
      this.lite = true;
      this.vids.forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); v.classList.remove('is-on'); });
      this.jump(this.cur, true);
    }
    showStill(i) {
      var r = this.rooms[i], s = this.still, op = this.pos(r.focus) + ' 50%';
      if (!r.p) return Promise.resolve(null);
      return new Promise(function (res) {
        var img = new Image();
        img.onload = img.onerror = function () { s.classList.remove('is-on'); s.src = r.p; s.style.objectPosition = op; requestAnimationFrame(function () { s.classList.add('is-on'); }); res(null); };
        img.src = r.p;
      });
    }
    // from / to: crop focus at the first and last frame. A walk-in clip pans the crop between rooms.
    show(list, loop, from, to) {
      var self = this;
      if (this.lite) return Promise.resolve(null);
      return new Promise(function (res) {
        var back = self.vids[1 - self.front];
        back.loop = loop;
        back.style.transition = 'opacity .5s ease';
        back.style.objectPosition = self.pos(from) + ' 50%';
        var k = 0;
        back.onerror = function () { k++; if (k < list.length) { back.src = list[k]; back.load(); } };
        back.src = list[0]; back.load();
        var go = function () {
          back.currentTime = 0;
          var p = back.play(); if (p && p.catch) p.catch(function () {});
          back.classList.add('is-on'); self.vids[self.front].classList.remove('is-on');
          if (self.poster) { self.poster.remove(); self.poster = null; }
          var old = self.vids[self.front]; self.front = 1 - self.front;
          setTimeout(function () { old.pause(); }, 600);
          if (to !== from) {
            var d = (back.duration && isFinite(back.duration)) ? back.duration : 6;
            requestAnimationFrame(function () { requestAnimationFrame(function () {
              back.style.transition = 'opacity .5s ease, object-position ' + d.toFixed(2) + 's cubic-bezier(.45,0,.25,1)';
              back.style.objectPosition = self.pos(to) + ' 50%';
            }); });
          }
          self.focusNow = to;
          res(back);
        };
        back.addEventListener('playing', function () { self.played = true; }, { once: true });
        if (back.readyState >= 3) go();
        else {
          back.addEventListener('canplay', go, { once: true });
          if (!self.played && (self.dataset.mode || 'auto') === 'auto') {
            setTimeout(function () { if (!self.played) self.goLite(); }, 6000);
          }
        }
      });
    }
    reset() {
      this.cap.classList.remove('is-on'); this.black.classList.remove('is-on', 'is-soft');
      this.end.classList.remove('is-on'); this.end.setAttribute('aria-hidden', 'true'); this.foot.style.opacity = 1;
    }
    openEnd() { this.black.classList.add('is-on', 'is-soft'); this.end.classList.add('is-on'); this.end.setAttribute('aria-hidden', 'false'); this.foot.style.opacity = 0; }

    play(i) {
      var self = this, my = ++this.token, r = this.rooms[i];
      var from = i === 0 ? r.focus : this.rooms[i - 1].focus;
      this.cur = i; this.reset(); this.setCopy(i);
      if (this.lite || !r.t.length) { this.jump(i, true); return; }
      this.show(r.t, false, from, r.focus).then(function (v) {
        if (my !== self.token || !v) return;
        self.warm(i + 1);
        if (r.l.length) {
          v.addEventListener('ended', function () {
            if (my !== self.token) return;
            self.show(r.l, true, r.focus, r.focus).then(function () { if (my === self.token) self.cap.classList.add('is-on'); });
          }, { once: true });
        } else {
          setTimeout(function () { if (my === self.token) self.cap.classList.add('is-on'); }, 2500);
          var f = function () {
            if (my !== self.token) { v.removeEventListener('timeupdate', f); return; }
            if (v.duration && v.currentTime > v.duration - 1.7) {
              v.removeEventListener('timeupdate', f);
              self.cap.classList.remove('is-on'); self.black.classList.add('is-on');
              setTimeout(function () { if (my === self.token) self.openEnd(); }, 1200);
            }
          };
          v.addEventListener('timeupdate', f);
        }
      });
    }
    jump(i, direct) {
      if (!direct && i === this.cur + 1) { this.play(i); return; }
      var self = this, my = ++this.token, r = this.rooms[i];
      this.cur = i; this.reset(); this.setCopy(i);
      if (this.lite) {
        if (this.poster) { this.poster.remove(); this.poster = null; }
        this.showStill(i).then(function () { if (my === self.token) self.cap.classList.add('is-on'); });
        return;
      }
      if (r.l.length) this.show(r.l, true, r.focus, r.focus).then(function () { if (my === self.token) self.cap.classList.add('is-on'); });
      else if (r.t.length) this.show(r.t, false, r.focus, r.focus).then(function (v) { if (v) v.currentTime = Math.max(0, (v.duration || 12) - 4.5); setTimeout(function () { if (my === self.token) self.cap.classList.add('is-on'); }, 600); });
      else this.cap.classList.add('is-on');
    }
  }
  customElements.define('mern-room-film', MernRoomFilm);
})();